import React from 'react'
import { guardarLogProducto } from '../../firebase/config'
import { Link } from 'react-router-dom'
import { upperFL } from '../../utils/utils'
import "./ProductosFav.css"

export const ProductosFav = ({ producto, premium, planName, user, handleLikeClick }) => {
  const currentUser = user;

  const handleProductClick = async (producto, currentUser, premium) => {
    if (!currentUser) {
      console.warn('Usuario no logueado. No se registrará el evento.');
      return;
    }

    const logData = {
      user: currentUser.uid,
      username: currentUser.username,
      tipo_prenda: producto.hierarchicalCategories,
      size: producto.size,
      brand: producto.brand,
      estate: producto.condition,
      city_producto: producto.city,
      platform: producto.web,
      price: producto.price,
      color: producto.color,
      sex_product: producto.sex,
      sex_user: currentUser.gender,
      birthdate_user: currentUser.birthdate,
      province_user: currentUser.province,
      is_premium: premium,
      plan: planName,
      is_save: true,
    };
        
    try {
      await guardarLogProducto(logData);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="producto-card">
      <img src={producto.images} alt={upperFL(producto.title)} />
      {
        premium && (
          <div class="precio-analisis">
            {producto.price_difference < 0 ? (
              <div class="precio-info">
                <span class="diferencia-porcentaje mejor-precio">
                  ⬇ {Math.abs(producto.percentage_price_difference).toFixed(2)}%
                </span>
                <span class="diferencia-euros mejor-precio">
                  -{Math.abs(producto.price_difference).toFixed(2)}€
                </span>
              </div>
            ) : (
              <div class="precio-info espacio-vacio"></div>
            )}
          </div>
        )
      }
      <div className="producto-info">
        <h3 className='titulo-producto'>{upperFL(producto.title)}</h3>
        <ul className="caracteristicas">
          <li className='fecha-producto'>
            <span className="valor-corte">
              {(() => {
                const now = new Date();

                // Convertir Firestore Timestamp a Date
                const scraped = new Date(producto.scraped_date.seconds * 1000);

                const diffTime = now - scraped;
                const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

                return `${diffDays} ${diffDays === 1 ? 'día' : 'días'} en eRastro`;
              })()}
            </span>
          </li>
          <li><strong>Talla:</strong> {producto.size.toUpperCase()}</li>
          <li><strong>Estado:</strong> {upperFL(producto.condition)}</li>
          <li><strong>Marca:</strong> <span className="valor-corte">{upperFL(producto.brand)}</span></li>
          <li><strong>Ciudad:</strong> <span className="valor-corte">{upperFL(producto.city)}</span></li>
          <li><strong>Web:</strong> {upperFL(producto.web)}</li>
          <li><strong>Precio:</strong> {producto.price}€</li>
        </ul>

        <div className="botones-producto">
          {
              <a
                href={producto.link}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => handleProductClick(producto, currentUser, premium)}
              >
                <button>Ver Producto</button>
              </a>
          }

          {
            !premium && (
              <Link to="/premium">
                <button className="boton-favoritos">
                  Contrata un plan para Rastrear productos
                </button>
              </Link>
            )
          }

          {
            premium && (
              <button
                className={`boton-favoritos ${user.likes.includes(producto.id) ? 'quitar' : 'agregar'}`}
                onClick={() => handleLikeClick(producto)}
              >
                {user.likes.includes(producto.id)
                  ? 'Dejar de rastrear'
                  : 'Rastrear producto'}
              </button>

            )
          }
        </div>
      </div>
    </div>
  );
};

export default ProductosFav;
